var quizQuestions = [
  {
    question:
      'When positioning your body at a computer workstation, the head should be level or bent slightly forward, forward facing and balanced. Generally it is in-line with _________.',
    answers: {
      a: 'The hands',
      b: 'The legs',
      c: 'The torso',
      d: 'The feet',
    },
    description:
      'When positioning your body at a computer workstation, generally your head should be in-line with <strong>your torso</strong>.',
    correctAnswer: 'c',
  },
  {
    question: ' OSHA covers:',
    answers: {
      a: 'All employees and their employers under federal authority',
      b: 'All employees',
      c: 'All of the above',
      d: 'Self employed',
    },
    description: 'OSHA covers <strong>all employees and their employers under federal authority</strong>.',
    correctAnswer: 'a',
  },
  {
    question: ' Spoil piles and/or equipment must be kept at least ___ feet back from the edge of the excavation.',
    answers: {
      a: '15',
      b: '20',
      c: '5',
      d: '2',
    },
    description:
      'Spoil piles and/or equipment must be kept at least <strong>2 feet</strong> back from the edge of the excavation.',
    correctAnswer: 'd',
  },
  {
    question:
      ' A case of injury or illness is work related if an event or exposure in the work environment either caused or contributed to the resulting condition.',
    answers: {
      a: 'True',
      b: 'False',
    },
    description:
      'A case of injury or illness <strong>is work related</strong> if an event or exposure in the work environment either caused or contributed to the resulting condition.',
    correctAnswer: 'a',
  },
  {
    question: ' OSHA inspections are _____________ conducted without advance notice.',
    answers: {
      a: 'Almost always',
      b: 'Sometimes',
      c: 'Never',
      d: 'Always',
    },
    description: 'OSHA inspections are <strong>almost always</strong> conducted without advance notice.',
    correctAnswer: 'a',
  },
  {
    question: ' Poor housekeeping is responsible for several _____ hazards.',
    answers: {
      a: 'Crane and derrick',
      b: 'Ergonomic',
      c: 'Fall protection',
      d: 'Aisles and passageway',
    },
    description:
      'Poor housekeeping, such as wet floors, debris and other protruding objects, can create a hazardous <strong>aisle or passageway</strong>.',
    correctAnswer: 'd',
  },
  {
    question: ' Who is required to pay for Personal Protective Equipment (PPE) in most situations?',
    answers: {
      a: 'Employer and Employee',
      b: 'Employer',
      c: 'Employee',
      d: 'OSHA',
    },
    description: '<strong>The employer</strong> should pay for and provide PPE in most situations.',
    correctAnswer: 'b',
  },
  {
    question: ' In construction work, fall protection is needed at how many feet above a lower level (excluding scaffolds)?',
    answers: {
      a: '4',
      b: '5',
      c: '6',
      d: '7',
    },
    description: 'In construction work, fall protection is needed at <strong>6 feet or more</strong> above a lower level.',
    correctAnswer: 'c',
  },
  {
    question: "Employers are required to post the OSHA Job Safety and Health – It's the Law poster in your workplace.",
    answers: {
      a: 'True',
      b: 'False',
    },
    description: 'Employers <strong>are required</strong> to post the OSHA Job Safety and Health.',
    correctAnswer: 'a',
  },
  {
    question: 'A struck-by rolling object injury or death can occur when:',
    answers: {
      a: "Traffic signals aren't posted around construction areas at hazard points",
      b: "Workers don't receive safety training",
      c: 'No worker symbols are used to alert road users of workers on or near roadway',
      d: 'All of the above',
    },
    description:
      "A struck-by rolling object injury or death can occur when <strong>traffic signals aren't posted around construction areas at hazard points, workers don't receive safety training</strong>, and/or <strong>no worker symbols are used to alert road users of workers on or near roadway</strong>.",
    correctAnswer: 'd',
  },
];

// below is the actual quiz.js file that the questions/answers is fed into
const addAnimationClass = (node, className) => {
  if (node) {
    return new Promise((resolve, reject) => {
      node.classList.add('animation-on', className);
      function handleAnimationEnd(event) {
        event.stopPropagation();
        node.classList.remove('animation-on', className);
        resolve('Animation ended');
      }
      node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });
  }
};

let totalNumberOfQuestions = 0,
  numberOfQuestionShown = 5,
  answerInputCollection = '',
  hiddenQuestionCollection = '';

const quiz = {
  init: function (questions) {
    totalNumberOfQuestions = questions.length;
    const quizWrap = document.querySelector('.quiz-wrap');
    const quizHtml = `<ol class="questions ps-4"></ol>
                      <div class="quiz-nav my-4 py-3 d-flex w-100 justify-content-center align-items-center">
                        <span class="quiz-tally d-inline-block mx-1"></span>
                        <button class="show-more-btn btn btn-outline-primary next-btn mx-1" type="button">Show More</button>
                      </div>`;
    quizWrap.insertAdjacentHTML('beforeend', quizHtml);
    const questionsWrap = document.querySelector('ol.questions');
    const questionsArray = questions.map((questionItem, qIndex) => {
      const answers = Object.entries(questionItem.answers).map((item, index) => {
        const correct = item[0] === questionItem.correctAnswer ? 'y' : 'n';
        return `<label class="quiz-answer d-block">
                  <input name="q${qIndex}" value="${correct}" type="radio" />
                  <span>${item[1]}</span>
                </label>`;
      });
      const shown = qIndex < numberOfQuestionShown ? 'shown' : 'hidden';
      return `<li class="question-wrap ${shown} mb-4">
                <h3 class="question mb-2">${questionItem.question}</h3>
                ${answers.join('')}
                <div class="correct-description alert alert-success d-none mt-3">
                  <p class="mb-0 text-dark"><strong>Correct:</strong> ${questionItem.description}</p>
                </div>
              </li>`;
    });
    questionsWrap.insertAdjacentHTML('beforeend', questionsArray.join(''));
    document.querySelector('.quiz-nav .quiz-tally').innerHTML = `${numberOfQuestionShown} of ${totalNumberOfQuestions}`;
    document.querySelector('.quiz-wrap .show-more-btn').addEventListener('click', function () {
      quiz.showMore();
    });
    answerInputCollection = document.querySelectorAll(".question-wrap input[type='radio']");
    quiz.eventsInit();
  },
  checkAnswer: function (e) {
    const answer = e.target;
    const answerWrap = answer.closest('.quiz-answer');
    const answerCollection = answer.closest('.question-wrap').querySelectorAll('.quiz-answer');
    const correctDescription = answer.closest('.question-wrap').querySelector('.correct-description');
    if (answer.value === 'y') {
      answerWrap.classList.add('correct-answer');
      correctDescription.classList.remove('d-none');
      correctDescription.classList.add('d-block');
    } else {
      addAnimationClass(answerWrap, 'shakeX');
      for (let answer of answerCollection) {
        answer.classList.remove('correct-answer');
      }
      correctDescription.classList.remove('d-block');
      correctDescription.classList.add('d-none');
    }
  },
  eventsInit: function () {
    // need to grab the updated list of questions/answers in case new questions was added to the DOM
    answerInputCollection = document.querySelectorAll(".question-wrap input[type='radio']");
    for (let answer of answerInputCollection) {
      answer.addEventListener('click', quiz.checkAnswer, true);
    }
  },
  showMore: function () {
    // cleaning up event listener for optimization
    for (let answer of answerInputCollection) {
      answer.removeEventListener('click', quiz.checkAnswer, true);
    }
    hiddenQuestionCollection = document.querySelectorAll('.question-wrap.hidden');
    for (let i = 0; i < 5; i++) {
      hiddenQuestionCollection[i].classList.remove('hidden');
      hiddenQuestionCollection[i].classList.add('shown');
      numberOfQuestionShown++;
      if (numberOfQuestionShown === totalNumberOfQuestions) {
        break;
      }
    }
    if (numberOfQuestionShown >= totalNumberOfQuestions) {
      document.querySelector('.quiz-wrap .quiz-nav .show-more-btn').classList.add('d-none');
    }
    document.querySelector(
      '.quiz-wrap .quiz-nav .quiz-tally'
    ).innerHTML = `${numberOfQuestionShown} of ${totalNumberOfQuestions}`;
    quiz.eventsInit();
  },
};

quiz.init(quizQuestions);
